import React, { useState } from 'react';
import Bouton from '../../UI/Bouton/Bouton';
import AccesRestreins from 'hoc/AccesRestreins/AccesRestreins';
import AttenteRequete from 'hoc/AttenteRequete/AttenteRequete';
import Collapse from 'hoc/Collapse/Collapse';
import * as requestType from 'ressources/glossaires/glossaire_requetes';
import * as privilege from 'ressources/glossaires/glossaire_privileges';
import { checkMot } from 'ressources/functionJS/checkMot';
import { confirmeOnClick } from 'ressources/functionJS/confirmeOnClick';
import { AiFillEdit, AiFillDelete } from 'react-icons/ai';
import * as s from 'ressources/StyleGlobal/StyleGlobal';
import styles from './ProfilAlarmeXY.module.scss';
import FormulaireAlarmeXY from './FormulaireAlarmeXY/FormulaireAlarmeXY';

const ProfilAlarmeXY = (props: any) => {
  const [disaplyViewModification, setDisplayViewModification] =
    useState<boolean>(false);

  return (
    <div className={styles.ConteneurInfo}>
      <div className={[s.card_header, styles.hedes].join(' ')}>
        {/* logo "i"*/}
        <span className={styles.style}>
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            className="bi bi-info-circle-fill"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
            />
          </svg>
        </span>
        <span className={styles.style}>
          {checkMot('alarm_xy_id')} : {props.infoAlarmeXY.alarm_xy_id}
        </span>
      </div>
      <div className={s.container}>
        <Collapse
          expandText={checkMot('info_general')}
          showAdvanceParameters={undefined}
          expandTextOuvert={undefined}
        >
          <div className={[s.col_md_12, styles.ConteneurProfilVue].join(' ')}>
            <div className={styles.text_profil_alarme_xy}>
              <FormulaireAlarmeXY
                preconfigurerAlarmeXY={props.infoAlarmeXY}
                annuler={() => setDisplayViewModification(false)}
                affichageProfil={!disaplyViewModification}
              />
              {disaplyViewModification ? null : (
                <div className={[s.row, styles.bts].join(' ')}>
                  <AccesRestreins numPrivilege={privilege.modifier_des_alarmes}>
                    <div className={styles.sas}>
                      <Bouton cliquer={() => setDisplayViewModification(true)}>
                        <AiFillEdit /> {checkMot('modifier')}
                      </Bouton>
                    </div>
                    <div className={styles.sas}></div>
                  </AccesRestreins>
                  <div className={styles.sas}>
                    <AccesRestreins
                      numPrivilege={privilege.supprimer_des_alarmes}
                    >
                      <AttenteRequete
                        request_type={
                          requestType.supprimer_une_configuration_d_alarme_xy
                        }
                        str={undefined}
                      >
                        <Bouton
                          cliquer={() =>
                            confirmeOnClick(
                              checkMot(
                                'voulez_vous_vraiment_supprimer_cette_alarme_xy'
                              ),
                              () =>
                                props.reqSupprimer(
                                  props.infoAlarmeXY.alarm_xy_id
                                )
                            )
                          }
                        >
                          <AiFillDelete /> {checkMot('supprimer')}
                        </Bouton>
                      </AttenteRequete>
                    </AccesRestreins>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Collapse>
      </div>
    </div>
  );
};

export default ProfilAlarmeXY;
